import React from 'react';

import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Tooltip } from 'primereact/tooltip';
import { EmployeeTriggerType } from 'types/interfaces/triggers';

interface MainTabProps {
  register: any;
  errors: any;
  withoutDialog?: boolean;
  handleInputChange: (currentTrigger: EmployeeTriggerType) => void;
  isUser?: boolean;
  isUserToggleDisabled?: boolean;
  usersLimitMessage?: string;
  dirtyFields: any;
  setValue: any;
  clearErrors: any;
  unregister: any;
  userErrors: string;
  isCustomProductivity?: boolean;
  onProductivityChange: () => void;
  onProductivityCalculatorClick: () => void;
  productivityCalculatorDisabled: boolean;
  productivityCalculationLoading: boolean;
  onOpenStartPointDialog: () => void;
  isLoading?: boolean;
}

const MainTab: React.FC<MainTabProps> = ({
  register,
  errors,
  withoutDialog,
  handleInputChange,
  isUser,
  isUserToggleDisabled,
  usersLimitMessage,
  dirtyFields,
  setValue,
  clearErrors,
  unregister,
  userErrors,
  isCustomProductivity,
  onProductivityChange,
  onProductivityCalculatorClick,
  productivityCalculatorDisabled,
  productivityCalculationLoading,
  onOpenStartPointDialog,
  isLoading
}) => {
  return (
    <>
      {isLoading ? (
        <div className="flex justify-content-center align-items-center p-5">
          <ProgressSpinner />
        </div>
      ) : (
        <div
          className={
            'flex flex-column md:flex-row gap-3 pb-0 ' +
            (withoutDialog ? '' : 'justify-content: justify-content-between')
          }
        >
          <div className="emploee-card__column  flex flex-column mr-4">
            <div className="flex flex-column">
              {userErrors && (
                <p
                  style={{ marginBottom: '1rem', height: '20px' }}
                  className={`employee-card-errors card-errors ${
                    userErrors ? 'text-red-500' : 'text-transparent'
                  } `}
                >
                  {userErrors ?? ' '}
                </p>
              )}
              <div className="flex justify-content-between align-items-center gap-3">
                <label className="user-card__label" htmlFor="personnelNumber">
                  Таб. номер<span className="required">*</span>:
                </label>
                <InputText
                  className="user-card__input"
                  {...register('personnelNumber', {
                    onChange: () => handleInputChange('personnelNumber')
                  })}
                />
              </div>
              <p
                className={`employee-card-errors card-errors ${
                  errors.personnelNumber ? 'text-red-500' : 'text-transparent'
                } `}
              >
                {errors.personnelNumber ? errors.personnelNumber.message : ' '}
              </p>
            </div>

            <div className="flex flex-column">
              <div className="flex justify-content-between align-items-center gap-3">
                <label className="user-card__label" htmlFor="surname">
                  Фамилия<span className="required">*</span>:
                </label>
                <InputText
                  className="user-card__input"
                  {...register('surname', {
                    onChange: () => handleInputChange('surname')
                  })}
                />
              </div>
              <p
                className={`employee-card-errors card-errors ${
                  errors.surname ? 'text-red-500' : 'text-transparent'
                } `}
              >
                {errors.surname ? errors.surname.message : ' '}
              </p>
            </div>

            <div className="flex flex-column">
              <div className="flex justify-content-between align-items-center gap-3">
                <label className="user-card__label" htmlFor="name">
                  Имя<span className="required">*</span>:
                </label>
                <InputText
                  className="user-card__input"
                  {...register('name', {
                    onChange: () => handleInputChange('name')
                  })}
                />
              </div>
              <p
                className={`employee-card-errors card-errors ${
                  errors.name ? 'text-red-500' : 'text-transparent'
                } `}
              >
                {errors.name ? errors.name.message : ' '}
              </p>
            </div>

            <div className="flex flex-column">
              <div className="flex justify-content-between align-items-center gap-3">
                <label className="user-card__label" htmlFor="middleName">Отчество:</label>
                <InputText
                  className="user-card__input"
                  {...register('middleName', {
                    onChange: () => handleInputChange('middleName')
                  })}
                />
              </div>
              <p
                className={`employee-card-errors card-errors ${
                  errors.middleName ? 'text-red-500' : 'text-transparent'
                } `}
              >
                {errors.middleName ? errors.middleName.message : ' '}
              </p>
            </div>

            <div className="flex gap-3">
              <Tooltip target=".isUser-limit-tooltip-target" />
              <span
                className={
                  isUserToggleDisabled ? 'isUser-limit-tooltip-target' : ''
                }
                data-pr-tooltip={
                  isUserToggleDisabled ? usersLimitMessage : undefined
                }
                data-pr-position="top"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.75rem',
                  opacity: isUserToggleDisabled ? 0.6 : 1,
                  cursor: isUserToggleDisabled ? 'not-allowed' : 'default'
                }}
              >
                <label
                  htmlFor="isUser"
                  style={{
                    color: isUserToggleDisabled ? '#6b7280' : undefined
                  }}
                >
                  Пользователь:
                </label>
                <Checkbox
                  {...register('isUser')}
                  checked={isUser!}
                  disabled={isUserToggleDisabled}
                  onChange={(e) => {
                    if (isUserToggleDisabled) return;
                    if (isUser === true && dirtyFields.login) {
                      setValue('login', '', {
                        shouldDirty: true,
                        shouldValidate: true
                      });
                    }
                    if (isUser === true && dirtyFields.password) {
                      unregister('password');
                      clearErrors('password');
                    }
                    setValue('isUser', e.checked || false, {
                      shouldDirty: true,
                      shouldValidate: true
                    });
                  }}
                />
              </span>
            </div>
          </div>

          <div className="emploee-card__column  flex flex-column">
            {userErrors && (
              <div style={{ marginBottom: '1rem', height: '20px' }} />
            )}
            <div className="flex flex-column">
              <div className="flex justify-content-between align-items-center gap-3">
                <label className="user-card__label" htmlFor="phone">Телефон:</label>
                <InputText
                  className="user-card__input"
                  {...register('phone', {
                    onChange: () => handleInputChange('phone')
                  })}
                />
              </div>
              <p
                className={`employee-card-errors card-errors ${
                  errors.phone ? 'text-red-500' : 'text-transparent'
                } `}
              >
                {errors.phone ? errors.phone.message : ' '}
              </p>
            </div>

            <div className="flex flex-column">
              <div className="flex justify-content-between align-items-center gap-3">
                <label className="user-card__label" htmlFor="email">
                  E-mail<span className="required">*</span>:
                </label>
                <InputText
                  className="user-card__input"
                  {...register('email', {
                    onChange: () => handleInputChange('email')
                  })}
                />
              </div>
              <p
                className={`employee-card-errors card-errors ${
                  errors.email ? 'text-red-500' : 'text-transparent'
                } `}
              >
                {errors.email ? errors.email.message : ' '}
              </p>
            </div>

            <div className="flex flex-column">
              <div className="flex justify-content-between align-items-center gap-3">
                <label className="user-card__label" htmlFor="productivity">
                  Производительность:
                  {isCustomProductivity === false ? (
                    <i
                      className="pi pi-exclamation-circle employee-productivity-auto-tooltip ml-1 mr-2"
                      style={{ color: 'rgb(255 168 0)', cursor: 'pointer' }}
                      data-pr-tooltip="Производительность рассчитана автоматически (наряды / час)"
                    />
                  ) : (
                    <i
                      className="pi pi-question-circle employee-productivity-manual-tooltip ml-1 mr-2"
                      style={{ cursor: 'pointer' }}
                      data-pr-tooltip="наряды / час"
                    />
                  )}
                </label>
                <Tooltip target=".employee-productivity-auto-tooltip" />
                <Tooltip target=".employee-productivity-manual-tooltip" />
                <div className="user-card__productivity-field">
                  <InputText
                    id="productivity"
                    className="user-card__input user-card__input--productivity-inner"
                    type="number"
                    {...register('productivity', {
                      onChange: onProductivityChange
                    })}
                  />
                  <Button
                    type="button"
                    icon="pi pi-calculator"
                    outlined
                    disabled={productivityCalculatorDisabled}
                    loading={productivityCalculationLoading}
                    onClick={onProductivityCalculatorClick}
                    tooltip="Автоматический расчет производительности"
                    tooltipOptions={{
                      position: 'top',
                      mouseTrack: true,
                      mouseTrackTop: 15
                    }}
                  />
                </div>
              </div>
              <p
                className={`employee-card-errors card-errors ${
                  errors.productivity ? 'text-red-500' : 'text-transparent'
                } `}
              >
                {errors.productivity ? errors.productivity.message : ' '}
              </p>
            </div>

            <div className="flex flex-column">
              <div className="flex flex-row justify-content-between align-items-center gap-3">
                <label style={{ minWidth: '103.69px' }}>Стартовая точка:</label>
                <Button
                  label="Настроить"
                  className="p-button-outlined flex-grow user-card__input"
                  onClick={onOpenStartPointDialog}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MainTab;
